// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CloudInventoryProviderSchema } from '../inputTypeSchemas/CloudInventoryProviderSchema'
import { CloudInventoryAccountStatusSchema } from '../inputTypeSchemas/CloudInventoryAccountStatusSchema'
import { DnsZoneDelegationStatusSchema } from '../inputTypeSchemas/DnsZoneDelegationStatusSchema'

/////////////////////////////////////////
// DNS ZONE SCHEMA
/////////////////////////////////////////

export const DnsZoneSchema = z.object({
  provider: CloudInventoryProviderSchema,
  status: CloudInventoryAccountStatusSchema,
  delegationStatus: DnsZoneDelegationStatusSchema,
  id: z.string(),
  tenantId: z.string(),
  accountRef: z.string(),
  zoneRef: z.string(),
  zoneName: z.string(),
  isPrivate: z.boolean(),
  nameservers: z.string().array(),
  observedNameservers: z.string().array(),
  recordCount: z.number().int(),
  soaSerial: z.number().int().nullable(),
  dnssecEnabled: z.boolean().nullable(),
  lastSyncedAt: z.coerce.date().nullable(),
  lastError: z.string().nullable(),
  delegationCheckedAt: z.coerce.date().nullable(),
  delegationVerifiedAt: z.coerce.date().nullable(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type DnsZone = z.infer<typeof DnsZoneSchema>

export default DnsZoneSchema;
